<template>
  <ModalOverlayDiv v-if="show" class="modal-overlay">
    <ModalDivArea class="modal-content" :style="{ width, height }" @click.stop>
      <ModalCloseBtn v-if="!hideCloseButton" class="close-button" @click="close">X</ModalCloseBtn>
      <ModalScrollArea>
        <slot></slot>
      </ModalScrollArea>
    </ModalDivArea>
  </ModalOverlayDiv>
</template>

<script>
import * as ModalCss from '@/assets/styles/global/modal.js';

const modalStack = [];

export default {
  components: {
    ...ModalCss,
  },

  name: 'ModalPage',

  props: {
    parent: {
      type: String,
      default: ""
    },
    show: {
      type: Boolean,
      required: true
    },
    width: {
      type: String,
      default: '95%' // 기본 너비
    },
    height: {
      type: String,
      default: '95%' // 기본 높이
    },
    hideCloseButton: {
      type: Boolean,
      default: false
    }
  },

  data() {
    let scroll_height = this.parent == "order" ? '100%' : this.height;
    return {
      scroll_height: scroll_height,
      modalId: Date.now() + Math.random().toString(36).substr(2, 9)
    }
  },

  methods: {
    close() {
      this.$emit('update:show', false);
    }
  },

  created() {
    this.handleEscKey = (event) => {
      if (event.key === 'Escape' && this.show) {
        // 가장 최근에 열린 모달인 경우에만 닫기
        if (modalStack.length > 0 && modalStack[modalStack.length - 1] === this.modalId) {
          this.$emit('update:show', false);
        }
      }
    };
    document.addEventListener('keydown', this.handleEscKey);
  },

  mounted() {
    // 모달이 이미 열려있는 상태로 마운트된 경우 스택에 추가
    if (this.show) {
      modalStack.push(this.modalId);
      document.body.style.overflow = 'hidden';
    }
  },

  beforeUnmount() {
    document.removeEventListener('keydown', this.handleEscKey);

    // 컴포넌트가 제거될 때 스택에서도 제거
    const index = modalStack.indexOf(this.modalId);
    if (index !== -1) {
      modalStack.splice(index, 1);

      // 모든 모달이 닫혔을 때만 body 스크롤 복원
      if (modalStack.length === 0) {
        document.body.style.overflow = 'auto';
        // 추가: 스크롤 복원을 위한 타임아웃 설정
        setTimeout(() => {
          document.body.style.overflow = 'auto';
        }, 100);
      }
    }
  },

  watch: {
    show(newVal) {
      if (newVal) {
        // 모달이 열릴 때 스택에 추가
        modalStack.push(this.modalId);

        // 모달이 열릴 때 body 스크롤 방지
        document.body.style.overflow = 'hidden';
      } else {
        // 모달이 닫힐 때 스택에서 제거
        const index = modalStack.indexOf(this.modalId);
        if (index !== -1) {
          modalStack.splice(index, 1);
        }

        // 모든 모달이 닫혔을 때만 body 스크롤 복원
        if (modalStack.length === 0) {
          document.body.style.overflow = 'auto';
          // 추가: 스크롤 복원을 위한 타임아웃 설정
          setTimeout(() => {
            document.body.style.overflow = 'auto';
          }, 100);
        }
      }
    }
  }
};
</script>